import { InterviewerParticipant } from '../../../../../entities/applicant_tracking/InterviewerParticipant';
import { User } from '../../../../../entities/User';

export function userToParticipantMapper(
  users: User[],
  meetingOrganizerUserId?: number,
): InterviewerParticipant[] {
  if (!users) return [];

  return users.map((user) => ({
    user,
    isMeetingOrganizer: user.id === meetingOrganizerUserId,
    ignoreCalendar: false,
  }));
}
